import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { DueStatus } from "./okr-dates";

interface DueBadgeProps {
    status: DueStatus;
}

/** Overdue/Due soon badge shared by Objective and KR rows. */
export function DueBadge({ status }: DueBadgeProps) {
    if (!status) return null;
    return (
        <span className={cn(
            "inline-flex items-center gap-0.5 text-[9px] font-semibold shrink-0",
            status === "overdue" ? "text-destructive" : "text-amber-600 dark:text-amber-500",
        )}>
            <Clock className="h-2.5 w-2.5" /> {status === "overdue" ? "Overdue" : "Due soon"}
        </span>
    );
}
